import React, { useContext, useMemo } from "react";
import "./ButtonHandler.css";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import * as c from "utils/constants/constants";
import { useDispatch } from "react-redux";
import { PATIENT_CREATE_ACTIONS_CONSTANTS } from "../../../redux/patientCreate/actions/actionTypes";
import { FormatDate } from "commonFunctions/commonFunctions";
import { uploadToOnbase } from "../Service/api";

const ButtonHandler = (props) => {
    const {
        data = {},
        duplicateDocumentView,
        isSave,
        saveAllData,
        update_patient_create_info,
        patient_create,
        maximise_patient_create,
        update_doc_info,
        documentId,
        setDialogs,
        docSplit,
        splitDocument,
        classificationMappingData,
        skipUpload,
        selectedFlags,
        enableMarkAsCompleteButton,
        enableUploadButton,
        enableCompleteButton
    } = useContext(DocumentDetailContext);

    const dispatch = useDispatch();

    const enableDocSplitButton = useMemo(() => {
        if (isSave) return false;
        else if (docSplit.isDocSplitEnabled && data?.Entity_Details.enable_doc_split) return true;
        else return false;
    }, [isSave, data, selectedFlags]);

    const enablePatientCreateBtn = useMemo(() => {
        if (data.Entity_Details?.is_block_fax) return false;
        
        if (data.Status == c.status.processed || data.Status == c.status.intervention_rqd) {
            if (selectedFlags["DOC SPLIT"])
                return false
            return !data?.MRN && !selectedFlags["SPAM"] && !data.Entity_Details?.is_new_patient
        }

    }, [data, selectedFlags]);

    const enableMatchPatientButton = useMemo(() => {
        if(data.Entity_Details?.is_block_fax) return false;
        if (isSave || docSplit.isDocSplitEnabled || data.MRN || selectedFlags["INCOMPLETE"] || selectedFlags["MULTI PT"] || selectedFlags["DOC SPLIT"]) return false;
        else if (data.Status == c.status.intervention_rqd) {
            return Object.hasOwn(data.Entity_Details.extraction, "patientName") &&
                Object.hasOwn(data.Entity_Details.extraction, "dateOfBirth")
        }
        return false;

    }, [isSave, data, selectedFlags, docSplit.isDocSplitEnabled]);



    const enableSaveChangesButton = useMemo(() => {
        if (isSave) {
            if (data.Status === c.status.processed || data.Status === c.status.intervention_rqd || data.Status === c.status.failed || (data.Status === c.status.completed && selectedFlags["CORRECT"])) return true;
            else return false;
        }

        return false;
    }, [isSave,])

    const checkPartialSplit = () => {
        if (docSplit?.splitProgressPercentage < 100) {
            setDialogs(prevState => ({
                ...prevState,
                partialDocumentSplitWarning: true
            }));
        } else {
            splitDocument()
        }
    }


    const getDocLevel = () => {
        var sub_category_val = data.Entity_Details.classify.documentSubCategory;
        return classificationMappingData[sub_category_val].doc_level.display_name;
    };

    const checkFieldsForUpload = () => {
        let uploadValidation = false, uploadWarning = false;
        let docLevel = data.Entity_Details.classify.documentLevel || getDocLevel();

        if (data.Status == c.status.failed) {
            uploadWarning = true;
        }

        if (docLevel == "Patient") {
            if (!data.Entity_Details.doc_description?.trim()) {
                uploadValidation = true;
            } else {
                uploadWarning = true;
            }
        } else if (docLevel == "Encounter") {
            if (!data.Entity_Details.doc_description?.trim() || Object.keys(data.Entity_Details.ehrDetails?.encounter || {}).length === 0) {
                uploadValidation = true;
            } else {
                uploadWarning = true;
            }
        } else if (docLevel == "Order") {
            if (!data.Entity_Details.doc_description?.trim() || Object.keys(data.Entity_Details.ehrDetails?.order || {}).length === 0) {
                uploadValidation = true;
            } else {
                uploadWarning = true;
            }
        }

        if (uploadValidation || uploadWarning) {
            setDialogs(prevState => ({
                ...prevState,
                uploadValidation,
                uploadWarning
            }))
        }
    }

    

    const discardChanges = () => {
        setDialogs(prevState => ({
            ...prevState,
            discardWarning: true,
        }));
    };

    const handleSkipComplete = () => {
        if (selectedFlags["JUNK"])
            skipUpload()
        else
            setDialogs(prevState => ({
                ...prevState,
                skipUploadWarning: true
            }))
    }

    const handleCompleteButton = () => {
        setDialogs(prevState => ({
            ...prevState,
            completeWarning: true
        }))
    }

    return <div className="button-section">
        {!duplicateDocumentView && data.Status != c.status.queued && data.Status != c.status.in_progress && <div className="button-groups">
            <div className="left-side-buttons">
                {(!isSave && enablePatientCreateBtn) && <button
                    className="apply-button"
                    style={{ width: "120px", marginRight: "0px" }}
                    type="submit"
                    onClick={() => {
                        let formattedName = data.Entity_Details?.formattedPatientName || "";
                        let dob = data.Entity_Details?.extraction?.dateOfBirth?.value || "";
                        let patientInfo = {
                            given_name: formattedName.split(", ")[1],
                            family_name: formattedName.split(", ")[0],
                            birth_date: FormatDate({ date: dob, format: "YYYY-MM-DD" }),
                            mobile_number: data.Entity_Details?.extraction?.phone_number?.value,
                            address: data.Entity_Details?.extraction?.address?.value || "",
                            country: "US",
                        }
                        dispatch(update_patient_create_info({ type: PATIENT_CREATE_ACTIONS_CONSTANTS.UPDATE_PATIENT_CREATE_DETAILS, payload: { ...patientInfo } }));
                        dispatch(patient_create({ type: PATIENT_CREATE_ACTIONS_CONSTANTS.TOGGLE_PATIENT_CREATE_POPUP, payload: { open: true, message: "popup open" } }));
                        dispatch(maximise_patient_create({ type: PATIENT_CREATE_ACTIONS_CONSTANTS.MAXIMISE_PATIENT_CREATE_POPUP, payload: true }));
                        dispatch(update_doc_info({ type: PATIENT_CREATE_ACTIONS_CONSTANTS.UPDATE_DOC_DETAILS, payload: { doc_id: documentId } }));
                    }
                    }
                >
                    <p className="apply-button-text">Create Patient</p>
                </button>}
            </div>
            <div className="right-side-buttons">
                {enableUploadButton ?
                    <button
                        className="apply-button upload-btn"
                        style={{ width: "120px" }}
                        type="submit"
                        onClick={checkFieldsForUpload}
                    >  <p className="apply-button-text">Upload</p>
                    </button> : null
                }
                {
                    enableMatchPatientButton &&
                    <button
                        className="apply-button"
                        style={{ width: "120px", marginRight: "0px" }}
                        type="submit"
                        onClick={() => saveAllData("pm")}
                    >
                        <p className="apply-button-text">Match Patient</p>
                    </button>
                }
                {enableCompleteButton ?
                    <button
                        className="apply-button"
                        style={{ width: "120px", marginRight: "10px" }}
                        type="submit"
                        onClick={handleCompleteButton}
                    >
                        <p className="apply-button-text">Complete</p>
                    </button>
                    : null}
                {enableDocSplitButton ? <button
                    className="apply-button"
                    style={{ padding: "0px 20px", width: "max-content", marginRight: "10px" }}
                    type="submit"
                    onClick={() => checkPartialSplit()}>
                    <p className="apply-button-text">Split Document</p>
                </button> : null}
                {enableMarkAsCompleteButton ? <button
                    className="apply-button"
                    style={{ width: "170px", marginRight: "0px" }}
                    type="submit"
                    onClick={() => handleSkipComplete(true, "no_pm")}>
                    <p className="apply-button-text">Mark as Complete</p>
                </button> : null}
                {
                    enableSaveChangesButton && <div style={{ display: "flex" }}>
                        <button
                            className="apply-button"
                            style={{ width: "120px" }}
                            type="submit"
                            onClick={() => {
                                saveAllData("save");
                            }}
                        >
                            <p className="apply-button-text">Save Changes</p>
                        </button>
                        <button
                            className="reset-button"
                            style={{ width: "140px" }}
                            type="submit"
                            onClick={() => {
                                discardChanges();
                            }}
                        >
                            <p className="reset-button-text">Discard Changes</p>
                        </button>
                    </div>
                }
            </div>
        </div>}
    </div>
}

export default ButtonHandler;